<template>
  <b-form @submit.prevent="submitForm">
    <b-form-group>
      <template v-slot:label>
        <div class="d-flex flex-row align-items-center justify-content-between">
          <div>Chọn file upload <span class="text-danger">*</span></div>
          <div><a href="static/import_user_template.xlsx" target="_blank">{{ $t("downloadSampleFile") }}</a></div>
        </div>
      </template>
      <b-form-file
        ref="fileInput"
        accept=".xlsx"
        placeholder=""
        @change.native="onFileChange"
      />
    </b-form-group>

    <div v-if="formErrorMsg" class="text-danger" v-html="formErrorMsg"></div>

    <div class="text-right pt-3">
      <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">{{
        $t("cancel") }}</b-button>
      <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("importFromFile") }}</b-button>
    </div>
  </b-form>
</template>

<style lang="scss" scoped></style>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import _ from "lodash";
import BaseComponent from "@/components/BaseComponent";
import * as userService from "@/service/userService";
import * as validationUtils from "@/service/validationUtils";
import readXlsxFile from 'read-excel-file';
import * as util from "@/service/util";
import {enumErrorType} from "@/views/enums/ErrorType";
@Component
export default class ImportUsersFromExcelFileModal extends BaseComponent {

  @Prop({ required: true }) modalId: string;
    // Emit decorators only
  @Emit("submitted") __submitted() { }

  file: File = null;

  formErrorMsg = "";
  isSubmitting = false;
  duplicateCells = [];
  
  b1Value = "";
  dupUserName = [];
  dupEmail = [];
  countUserName = {};
  countEmail = {};

  mounted() {

  }


  onClickCancel() {
    this.$bvModal.hide(this.modalId);
  }


  async submitForm() {
    this.formErrorMsg = "";
    this.isSubmitting = true;

    try {
      const isValid = await this.checkFileExcel(this.file);
      this.resetFile();
      if (!isValid) return;

      const res = await userService.uploadUsersExcelFile(this.file);
      if (res == true){
        this.__submitted();
        this.toastSuccessDelay(this.$t("importContactsFromFileSuccessful").toString());
        this.$bvModal.hide(this.modalId);
        return;
      }
      this.formErrorMsg = this.showError(res, enumErrorType.MESSAGE);
    } catch (e) {
      this.resetFile();
      this.toastError(e);
    } finally {
      this.isSubmitting = false;
    }
  }

  private async checkFileExcel(file: File): Promise<boolean> {
    try {
      const XLSX = await import("xlsx");
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(new Uint8Array(data), { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      // Không có dữ liệu
      if (!rows || rows.length < 2) {
        this.formErrorMsg = this.$t("fileExcelNotData").toString();
        return false;
      }

      const dataRows = rows.slice(1);
      let lastRowIndex = -1;
      for (let i = dataRows.length - 1; i >= 0; i--) {
        const row = (dataRows[i] || []) as any[]; 
        const hasData = row.some(
          (cell: any) =>
            cell !== null &&
            cell !== undefined &&
            cell.toString().trim() !== ""
        );
        if (hasData) {
          lastRowIndex = i;
          break;
        }
      }
      if (lastRowIndex === -1) {
        this.formErrorMsg = this.$t("fileExcelNotData").toString();
        return false;
      }

      const validRows = dataRows.slice(0, lastRowIndex + 1);
      for (let i = 0; i < validRows.length; i++) {
        const row = (validRows[i] || []) as any[];
        console.log("row: ", row);
        const hasData = row.some(
          (cell: any) =>
            cell !== null &&
            cell !== undefined &&
            cell.toString().trim() !== ""
        );
        if (!hasData) {
          this.formErrorMsg =
            this.$t("fileExcelEmptyRowBetween").toString();
          return false;
        }
      }
      // Kiểm tra email trùng lặp
      const emails = validRows
        .map(row => Array.isArray(row) ? (row[4]?.toString().trim().toLowerCase() || "") : "")
        .filter(email => email);

      const emailSet = new Set<string>();
      const duplicateEmails = emails.filter(email => {
        if (emailSet.has(email)) return true;
        emailSet.add(email);
        return false;
      });
      if (duplicateEmails.length > 0) {
        this.formErrorMsg = this.$t("emailDuplicated").toString() + ": " + duplicateEmails.join(", ");
        return false;
      }

      // Kiểm tra tên đăng nhập trùng lặp
      const userLogin = validRows
        .map(row => Array.isArray(row) ? (row[1]?.toString().trim().toLowerCase() || "") : "")
        .filter(user => user);

      const userLoginSet = new Set<string>();
      const duplicateUserLogin = userLogin.filter(user => {
        if (userLoginSet.has(user)) return true;
        userLoginSet.add(user);
        return false;
      });

      if (duplicateUserLogin.length > 0) {
        this.formErrorMsg = this.$t("userDuplicated").toString() + ": " + duplicateUserLogin.join(", ");
        return false;
      }
      // Kiểm tra họ tên
      for (let i = 0; i < validRows.length; i++) {
        if (!validRows[i][0] || validRows[i][0].toString().length < 2) {
          this.formErrorMsg = this.$t("fileExcelFullName").toString();
          return false;
        }
      }
      return true;
    } catch (err) {
      this.formErrorMsg = this.$t("fileExcelReadError").toString();
      return false;
    }
  }

  private resetFile() {
    if (this.$refs.fileInput) {
      (this.$refs.fileInput as any).reset();
    }
    // this.file = null;
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files ? input.files[0] : null;

    if (file) {
      this.file = file;
      input.value = "";
    }
  }
  //handle error
  
}
</script>